import { render, staticRenderFns } from "./FGTSList.vue?vue&type=template&id=6f3e2a3f"
import script from "./FGTSList.vue?vue&type=script&lang=js"
export * from "./FGTSList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports